
import { BankerEntity, EMPTY_BANKER_ENTITY } from "domain/entity/Banker/BankerEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { ChargeOnCompanyMappingViewChangeState } from "../ChargeOnCompanyMapping/ChargeOnCompanyMappingModel";
import { DropdownProps } from "../DropdownProps";

export interface BankerDropdownOptions {
    currencyCodeDropdownOptions: DropdownProps[],
}

export interface BankerModel {
    isLoading: boolean,
    dynamicOptions: BankerDropdownOptions,
    bankerList: BankerEntity[],
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: BankerEntity[],
    currentRow: BankerEntity,
    currentEditRow: BankerEntity,
    masterState: ChargeOnCompanyMappingViewChangeState,
}
export interface BankerViewChangeState extends BaseViewChangeSate {
}

export const EMPTY_BANKER_MODEL: BankerModel = {
    isLoading: false,
    bankerList: [],
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_BANKER_ENTITY },
    currentEditRow: { ...EMPTY_BANKER_ENTITY },
    dynamicOptions: {
        currencyCodeDropdownOptions: []
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}